module.exports = __webpack_public_path__ + "img/total-lazada-voucher.c96255a9.png";